module.exports = __webpack_public_path__ + "static/media/intro.bd7d3781.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/Drone/intro.mp4
// module id = 314
// module chunks = 0